import React from "react";
import RequestEngine from "../../core/RequestEngine";
import strings from "../../core/translate";
import { apiErrorMessage } from "../../shared/api-error";
import {
  FormSection,
  FormGrid,
  TextField,
  SwitchField,
  FormAlert,
  FormActions,
} from "../../components/Form/FormKit";

// A currency a garage can price in. The code is the stable identifier the
// backend matches on, so it is stored upper case.
export default class CurrencyForm extends React.Component {
  constructor(props) {
    super(props);
    const currency = props.item || {};
    this.state = {
      id: currency.id || "",
      version: currency.version,
      name: currency.name || "",
      code: currency.code || "",
      symbol: currency.symbol || "",
      isActive: currency.id ? !!currency.isActive : true,
      loading: false,
      error: "",
      errors: {},
    };
    this.engine = new RequestEngine();
  }

  validate() {
    const { name, code, symbol } = this.state;
    const errors = {};
    if (`${name}`.trim().length < 2) {
      errors.name = strings.name_min_hint;
    }
    if (`${code}`.trim().length < 2) {
      errors.code = strings.currency_code_min_hint;
    }
    if (`${symbol}`.trim().length === 0) {
      errors.symbol = strings.currency_symbol_required_hint;
    }
    return errors;
  }

  handleSubmit = async (event) => {
    event.preventDefault();

    const errors = this.validate();
    if (Object.keys(errors).length > 0) {
      this.setState({ errors });
      return;
    }

    const { id, version, name, code, symbol, isActive } = this.state;
    this.setState({ loading: true, error: "", errors: {} });

    const payload = {
      name: `${name}`.trim(),
      code: `${code}`.trim().toUpperCase(),
      symbol: `${symbol}`.trim(),
      isActive,
    };

    try {
      const response = id
        ? await this.engine.updateItem("currencies", id, {
            ...payload,
            version,
          })
        : await this.engine.saveItem("currencies", payload);

      if (response && (response.status === 200 || response.status === 201)) {
        this.setState({ loading: false });
        this.props.onSaved(response.data);
        return;
      }
    } catch (err) {
      this.setState({ error: apiErrorMessage(err) });
    }
    this.setState({ loading: false });
  };

  render() {
    const { name, code, symbol, isActive, loading, error, errors } = this.state;

    return (
      <form className="mform" onSubmit={this.handleSubmit}>
        <FormSection title={strings.currency} icon="nc-icon nc-money-coins">
          <FormGrid>
            <TextField
              label={strings.name}
              required
              value={name}
              onChange={(value) => this.setState({ name: value })}
              error={errors.name}
            />
            <TextField
              label={strings.code}
              required
              help={strings.currency_code_hint}
              value={code}
              onChange={(value) =>
                this.setState({ code: `${value}`.toUpperCase() })
              }
              error={errors.code}
            />
          </FormGrid>
          <FormGrid full>
            <TextField
              label={strings.currency_symbol}
              required
              help={strings.currency_symbol_hint}
              value={symbol}
              onChange={(value) => this.setState({ symbol: value })}
              error={errors.symbol}
            />
          </FormGrid>

          <SwitchField
            label={strings.active}
            checked={isActive}
            onChange={(checked) => this.setState({ isActive: checked })}
          />
        </FormSection>

        <FormAlert>{error}</FormAlert>
        <FormActions onCancel={this.props.onCancel} loading={loading} />
      </form>
    );
  }
}
